<footer>TotalEnergies - MultiProduct Studio {{ currentYear }} ©</footer>
